import { Fragment } from 'react'
import { Container, Row } from 'reactstrap'
import { Breadcrumbs } from '../../../AbstractElements'
import { Typography, UIKits } from '../../../Constants/Constants'
import Headings from "./Headings/Headings";
import ColoredHeadings from "./ColoredHeadings/ColoredHeadings";
import FontWeight from "./FontWeight";
import Listing from "./Listing/ListingTypography";
import DisplayHeading from './DisplayHeadings';
import InlineTextElements from "./InlineTextElements";
import TextColor from "./TextColor";
import BlockQuotesCard from "./BlockQuotes";

const TypographyContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Typography} parent={UIKits} />
      <Container fluid>
        <Row>
          <Headings />
          <ColoredHeadings />
          <FontWeight />
          <Listing />
          <DisplayHeading />
          <InlineTextElements />
          <TextColor />
          <BlockQuotesCard />
        </Row>
      </Container>
    </Fragment>
  )
}

export default TypographyContainer